import { Skeleton } from '@/shared/components/ui/skeleton';

export function DeviceManagementPendingState() {
  return (
    <section className="flex min-h-0 flex-1 flex-col gap-3 p-4" aria-busy="true">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <Skeleton className="h-6 w-24" />
        <div className="flex items-center gap-2">
          <Skeleton className="size-7 rounded-full" />
          <Skeleton className="h-8 w-28" />
          <Skeleton className="h-8 w-32" />
        </div>
      </div>

      <div className="flex flex-wrap items-center gap-2">
        <Skeleton className="h-8 w-52" />
        <Skeleton className="h-8 w-44" />
        <Skeleton className="h-8 w-56" />
      </div>

      <div className="min-h-0 flex-1 rounded-lg border p-2">
        <Skeleton className="h-8 w-full" />
        <div className="space-y-2 p-2">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
        </div>
      </div>
    </section>
  );
}
